import { Resolver } from '@wellyes/react-router-extended';
import { ProjectType } from 'providence-types';
import { HttpService } from '@core/services';
import { AccountingHttpService } from '@core/services/http';
import { BROWSE_DEFAULT_FILTER_VALUE } from '@models/constants';

export class AccountingBrowseResolver implements Resolver {
  async resolve(): Promise<void> {
    await HttpService.getHttpRequests(
      AccountingHttpService,
    ).getAccountingBrowse({
      ...BROWSE_DEFAULT_FILTER_VALUE,
      showCompletedProjects: false,
      projectTypeMode: ProjectType.LTE,
    });

    await HttpService.getHttpRequests(
      AccountingHttpService,
    ).getAccountingBrowseFiltersOptions();
  }
}
